/**
 * Single switch for every supplement feature: the per-section Supplements tab,
 * the consolidated Supplements panel (screen + PDF), the Holobiome Roadmap
 * section (screen + PDF), their "Include in PDF" settings, and the Supplement
 * Settings brand toggles (incl. the BWH Labs second brand). They ship together,
 * so they read one flag rather than each repeating an env check that can drift.
 *
 * Within that, the brands split the two panels: the Holobiome Roadmap section
 * is the whole Systemic Formulas protocol — kits, add-ons and the by-pattern
 * table — and appears only when that brand is checked; the Supplements panel
 * carries every other brand.
 *
 * Currently: RELEASED — visible everywhere, including prod (2026-08-31).
 *
 * Kept as a function rather than deleted so the many call sites stay put and
 * the feature can be re-gated in one edit if it ever needs to be. bwhLabsVisible()
 * below still reads it, and stays held back on its own REACT_APP_ENV check.
 */
export function supplementsVisible(): boolean {
  return true;
}

/**
 * The BWH Labs second brand on top of that: its Supplement Settings checkbox,
 * its rows in the Supplements tab/panel, and its "Use code …" discount line.
 *
 * Hidden EVERYWHERE — local dev included, not just the deployed builds — while
 * the BWH Labs partnership is on hold and there is no real affiliate code to
 * put behind the "Use code …" line. The brand's code, data and tests all stay
 * in place; this one flag is the whole hold.
 *
 * To launch it, return `supplementsVisible()` (dev + slava, not prod) and then
 * remove prod's own hold when the feature goes live.
 */
export function bwhLabsVisible(): boolean {
  return false;
}
